




































































































import {
  Vue,
  Component, Prop,
} from "@/shared/vuepack";
import {
  ContributionsViewType,
  FundingOption,
  HsabSsoDestination,
  TransferSchedule
} from "@/shared/types";
import SchedulePersonalContributionV2 from "@/employee/components/contributionsV2/SchedulePersonalContributionV2.vue";
import PersonalOneTimeContributionForm from "@/employee/components/contributionsV2/PersonalOneTimeContributionForm.vue";
import PayrollOneTimeContributionForm from "@/employee/components/contributionsV2/PayrollOneTimeContributionForm.vue";
import ContributionsNavigation from "@/employee/components/contributionsV2/ContributionsNavigation.vue";
import OtherContributionForm from "@/employee/components/contributionsV2/OtherContributionForm.vue";
import ContributionPlannerWidget from "@/employee/components/widgets/ContributionPlannerWidget.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import TaxSavingsWidget from "@/employee/components/widgets/TaxSavingsWidget.vue";
import RecurringContribution from "@/employee/components/contributionsV2/RecurringContribution.vue";
import RecentContributions from "@/employee/components/contributions/RecentContributions.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import ReadOnlyContributions from "@/employee/components/contributionsV2/ReadOnlyContributions.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import ContributionsActivity from "@/shared/components/contributionsV3/ContributionsActivity.vue";
import ContributionScheduleTabs from "@/shared/components/contributionsV3/ContributionScheduleTabs.vue";
import { Location } from "vue-router";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";

@Component({
  components: {
    ContributionScheduleTabs,
    SchedulePersonalContributionV2,
    PersonalOneTimeContributionForm,
    ContributionsNavigation,
    ContributionPlannerWidget,
    ContributionsGraphWidget,
    TaxSavingsWidget,
    OtherContributionForm,
    PayrollOneTimeContributionForm,
    RecurringContribution,
    RecentContributions,
    SsoDeepLink,
    ReadOnlyContributions,
    GenericLoadingSpinner,
    ContributionsActivity
  }
})
export default class ContributionsV2 extends Vue {

  @Prop()
  activityPage: number;

  @Prop()
  schedulesPage: number;

  @Prop()
  tab: string;

  @Prop()
  routeToModifySchedule: (schedule: TransferSchedule) => Location;

  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  personalContributionSchedulesStore = usePersonalContributionSchedulesStore();
  portalCustomizationStore = usePortalCustomizationStore();
  partnerPortalStore = usePartnerPortalStore();

  RouteNames = RouteNames;

  ContributionsViewType = ContributionsViewType;
  activeTab = ContributionsViewType.Payroll;

  externalContributionsView = false;

  mounted (): void {
    if (this.userStore.isIndividualAccountType ||
      this.userStore.employeeFundingOption !== FundingOption.BendCalculatePull ||
      !this.custodianSettingsStore.allowUserToEditContributions) {
      this.activeTab = ContributionsViewType.Personal;
    }

    if (this.useContributionsV3) {
      this.personalContributionSchedulesStore.getPersonalContributionSchedulingEligibility();
    }

    this.$on("contributions-view-change", event => {
      this.activeTab = event;
    });
  }

  get hasNoActivehsaAccount () {
    return !this.partnerPortalStore.hasActiveAccount;
  }

  get showManagePayrollContributions () {
    return this.userStore.employeeFundingOption === FundingOption.BendCalculatePull;
  }

  get payrollPanelActive (): boolean {
    return this.activeTab === ContributionsViewType.Payroll;
  }

  get personalPanelActive (): boolean {
    return this.activeTab === ContributionsViewType.Personal;
  }

  get ssoDeepLinkContribute () {
    return HsabSsoDestination.ContributeToHSA;
  }

  get useContributionsV3 () {
    return this.featureFlagStore.flags.bend16612ContributionHandling &&
      this.custodianSettingsStore.isHsaBankCustodian;
  }

  get showUnableToMakeContributionTooltip () {
    return this.useContributionsV3 &&
      !this.personalContributionSchedulesStore.isContributionSchedulingEligibilityLoading &&
      !this.personalContributionSchedulesStore.isUserEligibleToScheduleContribution &&
      this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }
}
